import Router from 'next/router';

const FindASpaceMenuComponent = () => {
    
    const onBrowseByCityClick = () => {
        Router.push('/play/own-your-city');
    };

    const onBrowseByBuildingsClick = () => {
        Router.push('/buildings');
    };

    return (
        <div className="menu-grid-item menu-grid-md-12 menu-grid-lg-6">
            <h5 style={{ marginBottom: '15px' }}>Find a Space</h5>
            <ul className='menu-list-root menu-list-padding'> 
                <div className='menu-button-base-root menu-list-item-root menu-list-item menu-list-item-gutters menu-list-item-button'
                    tabIndex="0" role="button" aria-disabled="false" id="menu-link-browse-by-city"
                     onClick={onBrowseByCityClick}
                >
                    <div className="menu-list-item-text-root menu-link">
                        <span className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                            Browse by City
                        </span>
                    </div>
                    <span className="menu-touch-ripple-root"></span>
                </div>

                <div className='menu-button-base-root menu-list-item-root menu-list-item menu-list-item-gutters menu-list-item-button'
                    tabIndex="0" role="button" aria-disabled="false" id="menu-link-browse-by-city"
                     onClick={onBrowseByBuildingsClick}
                >
                    <div className="menu-list-item-text-root menu-link">
                        <span className="menu-typography-root menu-list-item-text-primary menu-typography-body1 menu-typography-display-block">
                            Explore Buildings
                        </span>
                    </div>
                    <span className="menu-touch-ripple-root"></span>
                </div>

            </ul>
        </div>
    );
};

export default FindASpaceMenuComponent;
